import { render } from "./Subscription.vue?vue&type=template&id=5d85cbc7"
import script from "./Subscription.vue?vue&type=script&lang=js"
export * from "./Subscription.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src895191040/src/tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__